















export default {
    name: "Dropdown",
    props: {
        buttonClass: String,
        dropdownMenuClass: String,
        dropup: Boolean,
    },
    data() {
        return {
            open: false,
            id: "",
        };
    },
    methods: {
        toggle: function () {
            this.open = !this.open;
        },
    },
    created() {
        let self = this;
        self.id = _.uniqueId("dropdown-");
        window.addEventListener("click", function (e) {
            let dropdownNode = document.getElementById(self.id);
            if (dropdownNode && dropdownNode.contains(e.target as Node)) {
                // Clicked in box
            } else {
                self.open = false;
            }
        });
    },
};
